import React, { useEffect, useRef } from "react";
import "./MilestoneModal.css";

/** 매번 같은 하늘을 그리되 자리는 흩어지도록, 한 번만 계산해 둔다. */
const STARS = (() => {
  let seed = 111;
  const rnd = () => {
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return Array.from({ length: 38 }, () => ({
    x: +(rnd() * 100).toFixed(1),
    y: +(rnd() * 100).toFixed(1),
    o: +(0.15 + rnd() * 0.55).toFixed(2),
    d: +(rnd() * 3).toFixed(2),
  }));
})();

/**
 * MUROO 의 111번째 책을 놓은 사람에게만 뜨는 축하 화면.
 *
 * 자주 볼 화면이 아니다. 한 번 뜨고 끝이므로 닫기 외의 동작은 두지 않는다.
 */
export default function MilestoneModal({ milestone, onClose }) {
  const closeRef = useRef(null);

  useEffect(() => {
    closeRef.current?.focus();
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!milestone) return null;
  const { n, book } = milestone;

  return (
    <div className="ms-overlay" onClick={onClose}>
      <div
        className="ms-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ms-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="ms-sky" aria-hidden="true">
          {/* 자리는 고정하되 눈에는 흩어져 보이게 — 규칙적인 난수는 별이 아니라 격자가 된다 */}
          {STARS.map((st, i) => (
            <span
              key={i}
              className="ms-star"
              style={{
                left: `${st.x}%`,
                top: `${st.y}%`,
                opacity: st.o,
                animationDelay: `${st.d}s`,
              }}
            />
          ))}
          <div className="ms-planet" />
        </div>

        <div className="ms-num" aria-hidden="true">
          {String(n).split("").map((d, i) => (
            <span key={i}>{d}</span>
          ))}
        </div>

        <h2 id="ms-title" className="ms-title">
          MUROO의 {n}번째 책
        </h2>

        <div className="ms-book">
          <div className="ms-book-title">{book.title}</div>
          {book.author && <div className="ms-book-author">{book.author}</div>}
        </div>

        {/* 숫자는 위에서 이미 두 번 말했다. 여기서는 "당신" 만 남긴다. */}
        <p className="ms-body">
          당신이 놓은 별입니다.
          <br />
          <span className="ms-body-dim">이 순간은 MUROO에 기록으로 남습니다.</span>
        </p>

        <button ref={closeRef} className="ms-close" onClick={onClose}>
          고맙습니다
        </button>
      </div>
    </div>
  );
}
